module.exports = __webpack_public_path__ + "img/home-network-of-excellence.d13539fd.svg";